export default __webpack_public_path__ + "static/media/Katz.2e067b1c.png";